exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".chain-select .single-option-label{margin:0 6px}.chain-select .ant-select{width:auto}.chain-select .ant-select:not(:first-child){margin-left:8px}.chain-dropdown-overlay{min-width:200px}.chain-dropdown-overlay .ant-select-dropdown-menu{max-height:250px}", ""]);
